import { render, staticRenderFns } from "./FlatAccount.vue?vue&type=template&id=45889cd3&"
import script from "./FlatAccount.vue?vue&type=script&lang=js&"
export * from "./FlatAccount.vue?vue&type=script&lang=js&"
import style0 from "./FlatAccount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FlatAccount.vue"
export default component.exports